// src/App.js
import React from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import About from "./pages/About";
import Founder from "./pages/Founder";
import StudentSpace from "./pages/StudentSpace";
import Books from "./pages/Books";
import Blog from "./pages/Blog";
import Events from "./pages/Events";
import JoinUs from "./pages/JoinUs";
import Contact from "./pages/Contact";

import "./i18n"; // initialize i18n before any components that use translations

function App() {
  return (
    <div className="App">
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />

        {/* All merged into About */}
        <Route path="/about" element={<About />} />

        {/* Other core pages */}
        <Route path="/founder" element={<Founder />} />
        <Route path="/student-space" element={<StudentSpace />} />
        <Route path="/books" element={<Books />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/events" element={<Events />} />
        <Route path="/join" element={<JoinUs />} />
        <Route path="/contact" element={<Contact />} />

        {/* Optional catch-all: redirect unknown URLs back home */}
        {/* <Route path="*" element={<Navigate to="/" replace />} /> */}
      </Routes>

      <Footer />
    </div>
  );
}

export default App;
